import { lazy } from 'react';
import { Routes as RouterRoutes, Route } from 'react-router';

// CONSTANTS
import { ROUTE_SR_OVERVIEW, ROUTE_SR_REPORTS } from '@/constants/routes';

// UTILITY
import { retry } from '@/utility/routes';
import { getRoutes } from '@/routes/routes';

// HOC
import RouterLayout from '@/hoc/RouterLayout';

// COMPONENTS
import Redirect from '@/components/Redirect';

// CONTAINERS
const NotFound = lazy(() => retry(() => import('@/containers/NotFound')));

const routes = () => {
  const routerPaths = getRoutes();

  return (
    <RouterRoutes>
      {/* COMMON ROUTES */}
      {routerPaths.map(({ path, ...props }, i) => (
        <Route path={path} key={i} element={<RouterLayout {...props} />} />
      ))}

      {/* REDIRECTS */}
      <Route path={ROUTE_SR_REPORTS} element={<Redirect to={ROUTE_SR_OVERVIEW} />} />

      {/* NOT FOUND */}
      <Route path="*" element={<RouterLayout component={NotFound} />} />
    </RouterRoutes>
  );
};

export default routes;
